import { Model } from 'rwl-shared';
import {
    TRACKING_SESSION_ID,
    TRACKING_SHARE_ID,
} from '../SessionTracker/useTrackSession';

export default async function createShare(
    url: string,
    accountId: string,
    technician?: Model.PortfolioUser
): Promise<string> {
    const sessionID = window.localStorage.getItem(TRACKING_SESSION_ID);
    const referringShareId =
        window.localStorage.getItem(TRACKING_SHARE_ID) ?? undefined;
    // shares that have a session but no technician are homeowner shares
    // shares that have a technician but no session are technician shares
    const useSessionId = !technician?.id && sessionID;
    const search = new URLSearchParams(window.location.search);
    const request: Model.CreateShareRequest = {
        utm: undefined,
        sessionId: useSessionId ? sessionID : undefined,
        technicianId: technician?.id,
        workSiteId: search.get('jobID') ?? undefined,
        initialUrl: window.location.href,
        referringShareId,
    };
    const response = await fetch(url + '?accountId=' + accountId, {
        method: 'POST',
        headers: {
            Accept: 'application.json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
    });
    const body = await response.json();
    return body.url;
}
